import { Component, EventEmitter, Inject, OnDestroy, OnInit } from '@angular/core';
import { CBM_GEMINI_PLAN_CODES, CONFIG_TOKEN, PlanCardsStatus, PlanCardsType, PlanEightPlanCodes } from 'core/constants';
import { Subscription } from 'rxjs';
import { CimaCore, Cloudinary, Formatter } from 'services/index';
import { XmStore, XmStoreUtil } from 'services/store';
import { Util } from 'services/util';
import { CmsDataDetail, CmsPlanSwitch } from 'store/cms/models';
import { targetPlanSwitchDetails } from 'store/plan-eligibility/models/target-plan-switch';
import { StateService, UIRouterGlobals } from '@uirouter/core';
import { AccountSummary, LineSummary } from 'store/account-summary/models';
import { User } from 'store/user/models';
import { DiscountPromoCollection, DiscountPromotion } from 'store/promotions/discount-promotion/models';
import { StoreAction } from 'store/actions';
import { UnlPlanSubgroupName } from 'my-account/constants';
import { IXMOptions } from 'core/interfaces';

@Component({
    selector: 'xm-unl-target-plan-review',
    styleUrls: ['./unl-plan-review.scss'],
    templateUrl: 'unl-plan-review.html',
    standalone: false
})

export class XmUnlTargetPlanSwitchReviewComponent implements OnInit, OnDestroy {
    public seg5BtgToUnlSwitchBanner: CmsSeg5BtgToUnlSwitchBanner;
    public pageData: targetPlanSwitchDetails;
    public cmsDataDetailPageData: CmsDataDetail;
    public inUse: string;
    public inUseIcon: MediaImageOptions;
    public scheduled: string;
    public scheduledIcon: MediaImageOptions;
    public alertIcon: MediaImageOptions;
    public infoIconGrey: MediaImageOptions;
    public dollarIcon: MediaImageOptions;
    public emitPlanCode: EventEmitter<string> = new EventEmitter<string>();
    public circleDeviceIcon: MediaImageOptions;
    public segmentSwitchIcon: MediaImageOptions;
    public totalBtgLinesCount: number;
    public user: User;
    public showPlanUpgradeBanner: boolean;
    public showSegmentUpgradeBanner: boolean;
    public selectedPlanCode: string = '';
    public isButtonDisabled: boolean = true;
    public buttonText: string;
    public planSevenUnlPlanSwitchCta: string;
    //promo
    public promotionData: string[] = [];
    public discountPromoResp: DiscountPromoCollection;
    public promoIcon: MediaImageOptions;
    public promotionHeader: string;
    public multiplePromotions: CmsPlanSwitchMultiplePromotions;
    public inEligibleInUsePlan: PlanCardsDetails;
    public lineSummary: LineSummary;
    public summary: AccountSummary;
    public isIcopPlanSwitch: boolean; 
    public allpromotionContent: PromotionContent[];
    public isBillPreviewEnabled: boolean = false;
    public isBtgLineId: boolean;
    public isBusinessUser: boolean;
    public isSeg6ResiUser: boolean = false;
    public segmentSwitchBanner: NotificationBanner;
    public isXMCGeminiPro: boolean = false;
    public isCBMGeminiEnabled: boolean = false;

    private subscriptions: Subscription[] = [];
    private xmStore: XmStore;
    private state: StateService;
    private globalRouterState: UIRouterGlobals;
    private config: IXMOptions;
    private cimaCore: CimaCore;

    constructor(xmStore: XmStore, state: StateService, globalRouterState: UIRouterGlobals, @Inject(CONFIG_TOKEN) config: IXMOptions, cimaCore: CimaCore ) {
        Object.assign(this, { xmStore, state, globalRouterState, config, cimaCore });
    }

    public ngOnInit(): void {
        this.isBusinessUser = this.cimaCore.isBusinessUser;
        this.isIcopPlanSwitch = this.config.ENABLE_ICOP_P1_PLANSWITCH;
        this.isXMCGeminiPro = this.config.ENABLE_XMC_CBM_GEMINI_PRO && this.cimaCore.isBusinessUser;
        this.isBillPreviewEnabled = (this.config.ENABLE_BILL_PREVIEW && !this.cimaCore.isBusinessUser) || (this.config.ENABLE_CBM_BILL_PREVIEW && this.cimaCore.isBusinessUser);

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<targetPlanSwitchDetails>(targetPlanSwitchDetails), (result: targetPlanSwitchDetails) => {
            this.pageData = result;
            this.buttonText = (this.isBillPreviewEnabled && this.pageData?.selectionPage?.ctas?.reviewDetails) ? this.pageData.selectionPage.ctas.reviewDetails : this.pageData.selectionPage.ctas.switch;
            this.allpromotionContent = this.pageData.allPromoContent;
        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<AccountSummary>(AccountSummary), (summary: AccountSummary) => {
            this.summary = summary;
            this.lineSummary = summary.getLineByKey(this.state.params.line_id);
        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<User>(User), (user: User) => {
            this.user = user;
            this.isSeg6ResiUser = this.user.account.isSegmentSix && !this.cimaCore.isBusinessUser;
            this.isCBMGeminiEnabled = this.config.ENABLE_CBM_GEMINI && this.isBusinessUser && this.user.account.isNoLevel;
            this.showPlanUpgradeBanner = this.user.account.isSegmentFive && this.summary.getBtgLineCountAndLineId().lineCount === 1 && (this.lineSummary.isBtgLine || this.lineSummary.id.key === this.summary.getBtgLineCountAndLineId().lineId);
            this.showSegmentUpgradeBanner = (this.user.account.canMoveLevel || ((this.user.account.isSegmentFive && !this.cimaCore.isBusinessUser)
                && !this.user.account.isNYCustomer));
            if (this.showSegmentUpgradeBanner) {
                this.segmentSwitchBanner = Array.isArray(this.pageData?.selectionPage?.banners) ? this.pageData.selectionPage.banners[0] : undefined;
                this.segmentSwitchIcon = {
                    mobile: {
                        base: this.segmentSwitchBanner?.image
                    }
                };
            }
        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsPlanSwitch>(CmsPlanSwitch), (result: CmsPlanSwitch) => {
            this.planSevenUnlPlanSwitchCta = result.planSevenUnlPlanSwitchCta;
            this.seg5BtgToUnlSwitchBanner = result.seg5BtgToUnlSwitchBanner;
            this.multiplePromotions = result.planSwitchMultiplePromotions;
            this.circleDeviceIcon = {
                mobile: {
                    base: this.seg5BtgToUnlSwitchBanner.mobileImage
                },
                smallDesktop: {
                    base: this.seg5BtgToUnlSwitchBanner.desktopImage
                }
            };
        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsDataDetail>(CmsDataDetail), (DataDetails: CmsDataDetail) => {
            this.cmsDataDetailPageData = DataDetails;
            this.inUse = this.cmsDataDetailPageData.inUse;
            this.scheduled = this.cmsDataDetailPageData.scheduled;
        
            this.inUseIcon = {
                mobile: Cloudinary.generateMediaFromCms(this.cmsDataDetailPageData.inUseIcon)
            };
        
            this.scheduledIcon = {
                mobile: Cloudinary.generateMediaFromCms(this.cmsDataDetailPageData.scheduledIcon)
            };

            this.alertIcon = {
                mobile: Cloudinary.generateMediaFromCms(this.cmsDataDetailPageData.alertIcon)
            };

            this.infoIconGrey = {
                mobile: Cloudinary.generateMediaFromCms(this.cmsDataDetailPageData.infoIconGrey)
            };

            this.dollarIcon = {
                mobile: Cloudinary.generateMediaFromCms(this.cmsDataDetailPageData.dollarIcon)
            };
        }));

        if (!this.isIcopPlanSwitch && !this.isSeg6ResiUser && !this.isCBMGeminiEnabled) {
            XmStoreUtil.defaultCatch(this.xmStore.findPromise<DiscountPromoCollection>(StoreAction.GET_DISCOUNT_PROMOTION, DiscountPromoCollection))
                .then((response: DiscountPromoCollection) => {
                    this.discountPromoResp = response;
                    this.promoIcon = {
                        mobile: Cloudinary.generateMediaFromCms(this.cmsDataDetailPageData.servicePromotions.icon)
                    };
                    this.setPromotionDataForSeg5();
                });
        }
    }

    public onCancel(): void {
        this.state.go('account.activity.details', { line_id: this.globalRouterState.params.line_id });
    }

    public navToSwitchInProgress(): void {
        const isDowngradeToSelect: boolean = this.user.account.isSegmentSix && this.selectedPlanCode.includes(PlanEightPlanCodes.MOBILE_SELECT);
        const isDowngradeToStandard: boolean = this.isXMCGeminiPro && this.user.account.isNoLevel && this.selectedPlanCode.includes(CBM_GEMINI_PLAN_CODES.STANDARD);
        if (isDowngradeToSelect && this.pageData?.xmcSelectionPage && Object.keys(this.pageData.xmcSelectionPage).length > 0) {
            this.state.go('account.activity.details.plan-switch.xmc-consent-page', { line_id: this.globalRouterState.params.line_id, plan_code: this.selectedPlanCode, 
                xmcConsent: this.pageData.xmcSelectionPage });
        } else if (isDowngradeToStandard && this.pageData?.xmcSelectionPage && Object.keys(this.pageData.xmcSelectionPage).length > 0) {
            this.state.go('account.activity.details.plan-switch.xmc-consent-page', { line_id: this.globalRouterState.params.line_id, plan_code: this.selectedPlanCode, 
                xmcConsent: this.pageData.xmcSelectionPage });
        } else if ((isDowngradeToSelect || isDowngradeToStandard) && Object.keys(this.pageData.xmcSelectionPage).length === 0) {
            this.state.go('account.activity.details.plan-switch.review-order', { line_id: this.globalRouterState.params.line_id, plan_code: this.selectedPlanCode, backButtonPath: 'account.activity.details.plan-switch.xm-unl-target-plan-review' });
        } else if (this.isBillPreviewEnabled && !this.isPlanActiveAndInUse(this.selectedPlanCode) && !((isDowngradeToSelect || isDowngradeToStandard) && (Object.keys(this.pageData.xmcSelectionPage).length === 0))) {
            this.state.go('account.activity.details.plan-switch.review-order', { line_id: this.globalRouterState.params.line_id, plan_code: this.selectedPlanCode, backButtonPath: 'account.activity.details.plan-switch.xm-unl-target-plan-review' });
        } else {
            this.state.go('account.activity.details.plan-switch.in-progress', { line_id: this.globalRouterState.params.line_id, plan_code: this.selectedPlanCode });
        }
    }

    public isPlanActiveAndInUse(planCode: string): boolean {
        return this.pageData.selectionPage.planCards.some(
            (card: PlanCardsDetails) => card.planCode === planCode && card.type === PlanCardsType.ACTIVE && card.badge === PlanCardsStatus.IN_USE
        );
    }

    public isPlanScheduled(planCode: string): boolean {
        return this.pageData.selectionPage.planCards.some(
            (card: PlanCardsDetails) => card.planCode === planCode && card.type === PlanCardsType.SCHEDULED && card.badge === PlanCardsStatus.SCHEDULED
        );
    }

    public hasBothActiveAndScheduledPlans(): boolean {
        const planCards: PlanCardsDetails[] = this.pageData.selectionPage.planCards;
        
        return planCards.some((card: PlanCardsDetails) => card.type === PlanCardsType.ACTIVE && card.badge === PlanCardsStatus.IN_USE) &&
               planCards.some((card: PlanCardsDetails) => card.type === PlanCardsType.SCHEDULED && card.badge === PlanCardsStatus.SCHEDULED);
    }
    
    public tierSelect(planCode: string): void {
        this.selectedPlanCode = planCode;
        this.emitPlanCode.emit(planCode);
    
        const isActiveAndInUse: boolean = this.isPlanActiveAndInUse(planCode);
        const isInactiveAndScheduled: boolean = this.isPlanScheduled(planCode);
    
        this.isButtonDisabled = this.hasBothActiveAndScheduledPlans() ? isInactiveAndScheduled : isActiveAndInUse;
        this.buttonText = this.hasBothActiveAndScheduledPlans() && isActiveAndInUse ? this.planSevenUnlPlanSwitchCta 
            : (this.isBillPreviewEnabled && this.pageData?.selectionPage?.ctas?.reviewDetails) ? this.pageData.selectionPage.ctas.reviewDetails : this.pageData.selectionPage.ctas.switch;
    }
    
    public setRadioData(planCard: PlanCardsDetails): XmRadioOption {
        return {
            value: planCard.planCode,
            groupName: 'plan',
            labelFor: planCard.planCode
        };
    }

    public showInUseBadge(planCard: PlanCardsDetails): boolean {
        const isInuse: boolean = planCard.type === PlanCardsType.ACTIVE && planCard.badge === PlanCardsStatus.IN_USE;
        if (isInuse) {
            this.inEligibleInUsePlan = planCard;
        }

        return isInuse;
    }

    public showScheduledBadge(planCard: PlanCardsDetails): boolean {
        return planCard.type === PlanCardsType.SCHEDULED && planCard.badge === PlanCardsStatus.SCHEDULED;
    }

    public getPromoIcon(iconType: string): MediaImageOptions {
        switch (iconType?.toLowerCase()) {
            case 'warning':
                return this.alertIcon;
            case 'offer':
                return this.infoIconGrey;
            case 'savings':
                return this.dollarIcon;
            default:
                return this.alertIcon;
        }
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }

    // Displaying promo container temp. Needs to be replaced post CEUIDSS-29611 & CEUIDSS-29620 completion
    private setPromotionDataForSeg5(): void {
        if (this.multiplePromotions && this.discountPromoResp) {
            this.promotionHeader = this.discountPromoResp.isTradeInDDAPromoEligible && (this.inEligibleInUsePlan.name === UnlPlanSubgroupName.PLUS || this.inEligibleInUsePlan.name === UnlPlanSubgroupName.PREMIUM ||
                this.inEligibleInUsePlan.name === UnlPlanSubgroupName.TABLET_PREMIUM) ? this.multiplePromotions.unlTiersReviewContentSeg5.generalDowngrade : this.multiplePromotions.unlTiersReviewContentSeg5.general;
            this.promotionData = this.getPromoDescription(this.promotionData);
        }
    }

    private getPromoDescription(promotionData: string[]): string[] {
        if (this.discountPromoResp.accountPromoEligible?.length > 0) {
            if (this.user.account.isSegmentFive) {
                this.discountPromoResp.accountPromoEligible.map((promo: DiscountPromotion) => {
                    promotionData.push(this.getPromoDateAmount(this.multiplePromotions.unlTiersReviewContentSeg5.UNL, promo));
                });
            } else {
                this.discountPromoResp.accountPromoEligible.map((promo: DiscountPromotion) => {
                    promotionData.push(this.getPromoDateAmount(this.multiplePromotions.unlTiersReviewContent.UNL, promo));
                });
            }
        }

        if (this.discountPromoResp.linePromoUNLEligible?.length > 0) {
            if (this.user.account.isSegmentFive) {
                this.discountPromoResp.linePromoUNLEligible.map((promo: DiscountPromotion) => {
                    promotionData.push(this.getPromoDateAmount(this.multiplePromotions.unlTiersReviewContentSeg5.UNL, promo));
                });
            } else {
                this.discountPromoResp.linePromoUNLEligible.map((promo: DiscountPromotion) => {
                    promotionData.push(this.getPromoDateAmount(this.multiplePromotions.unlTiersReviewContent.UNL, promo));
                });
            }
        }

        if (this.discountPromoResp.linePromoBYOEligible?.length > 0) {
            if (this.user.account.isSegmentFive) {
                this.discountPromoResp.linePromoBYOEligible.map((promo: DiscountPromotion) => {
                    promotionData.push(this.getPromoDateAmount(this.multiplePromotions.unlTiersReviewContentSeg5.BYO, promo));
                });
            } else {
                this.discountPromoResp.linePromoBYOEligible.map((promo: DiscountPromotion) => {
                    promotionData.push(this.getPromoDateAmount(this.multiplePromotions.unlTiersReviewContent.BYO, promo));
                });
            }
        }

        if (this.discountPromoResp.isTradeInDDAPromoEligible) {
            const tradeInPromo: DiscountPromotion = this.discountPromoResp?.mvnoPromotions.find((promo: DiscountPromotion) =>
                promo.isTradeInDDAPromoEligible && (promo.lineId === this.lineSummary.id.key || promo.lineId === this.lineSummary.id.value)
            );

            if (tradeInPromo) {
                if (this.user.account.isSegmentFive) {
                    promotionData.push(this.multiplePromotions.unlTiersReviewContentSeg5.DDA.replace('[AMOUNT]', tradeInPromo.billerInfo.promotionAmount.toString()));
                } else {
                    promotionData.push(this.multiplePromotions.unlTiersReviewContent.DDA.replace('[AMOUNT]', tradeInPromo.billerInfo.promotionAmount.toString()));
                }
            }
        }

        if (this.discountPromoResp.isExtendedPromoDollarEligible) {
            const extendedDDAPromo: DiscountPromotion = this.discountPromoResp?.mvnoPromotions.find((promo: DiscountPromotion) =>
                promo.isExtendedPromoDollarEligible && (promo.lineId === this.lineSummary.id.key || promo.lineId === this.lineSummary.id.value)
            );

            if (extendedDDAPromo) {
                if (this.user.account.isSegmentFive) {
                    promotionData.push(this.multiplePromotions.unlTiersReviewContentSeg5.EPD.replace('[PROMO_AMOUNT]', extendedDDAPromo.billerInfo.promotionAmount.toString()));
                } else {
                    promotionData.push(this.multiplePromotions.unlTiersReviewContent.EPD.replace('[PROMO_AMOUNT]', extendedDDAPromo.billerInfo.promotionAmount.toString()));
                }
            }
        }

        return promotionData;
    }

    private getPromoDateAmount(description: string, promoResponse: DiscountPromotion): string {

        return description.replace('[AMOUNT]', promoResponse.billerInfo.monthlyPromotionValue).replace('[DATE]', Formatter.formatMonthDateYear(promoResponse.billerInfo.promotionExpiration));
    }

}
